// Formats whole US dollars the same way on the server and in the browser
export const formatPrice = (amount: number): string => `$${Math.round(amount).toLocaleString('en-US')}`

// Formats a date as YYYY-MM-DD in the visitor's own time zone
export const toDateString = (date: Date): string => {
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${date.getFullYear()}-${month}-${day}`
}

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

// Reads a YYYY-MM-DD date as a calendar day, with no time zone shift
export const weekdayOf = (value: string): number => new Date(`${value}T00:00:00Z`).getUTCDay()

export const formatLongDate = (value: string): string => {
    const date = new Date(`${value}T00:00:00Z`)
    if (Number.isNaN(date.getTime())) return value
    return `${WEEKDAYS[date.getUTCDay()]}, ${date.getUTCDate()} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`
}

// Short, readable reference for an order or booking id
export const shortReference = (prefix: string, id: string): string => `${prefix}-${id.replace(/-/g, '').slice(0, 6).toUpperCase()}`
